import React from "react";
import { Outlet } from "react-router-dom";
import Wrapper from "../components/Wrapper";
import Main from "../components/Main";
import Content from "../components/Content";
import { ScrollToTop } from "../ScrollToTop";

const LeapDashboard: React.FC = ({ children }) => (
  <ScrollToTop>
    <React.Fragment>
      <Wrapper>
        <Main>
          <Content>
            {children}
            <Outlet />
          </Content>
        </Main>
      </Wrapper>
    </React.Fragment>
  </ScrollToTop>
);

export default LeapDashboard;
